import classNames from "classnames/bind";
import Image from "common/blocks/Image";
import NewsletterSignUp from "features/home/components/NewsletterSignUp";
import type { ResolvedImage } from "resolvers/data/imageResolver";
import type { ResolvedSignupForm } from "resolvers/data/signupFormResolver";

import styles from "./Subscribe.module.scss";

const cx = classNames.bind(styles);

type Props = {
    image: ResolvedImage;
    signupForm: ResolvedSignupForm;
};

const Subscribe = (props: Props) => {
    const { image, signupForm } = props;

    return (
        <div className={cx("subscribe")}>
            <div className={cx("subscribeForm")}>
                <NewsletterSignUp
                    {...signupForm}
                    buttonClassName={cx("subscribeFormButton")}
                    formWrapperClassName={cx("subscribeFormWrapper")}
                />
            </div>
            <div className={cx("subscribeImageWrapper")}>
                <Image
                    className={cx("subscribeImage")}
                    layout="fill"
                    objectFit="cover"
                    {...image}
                    alt={image.alt}
                />
            </div>
        </div>
    );
};

export default Subscribe;
